module.exports = __webpack_public_path__ + "img/chucao.72c67e3d.png";